const createTrackingData = (eventType, page, data) => ({
  eventType,
  page,
  data,
})

const addFormProposal = (proposal, formProposal) => ({
  ...proposal,
  formProposal,
})

export default createTrackingData
export { addFormProposal }
